type UserRequestProps = {
    content: string;
};

let lastId = 0;

export default class UserRequest {
    /** Unique per question: the same question asked twice is two bubbles. */
    readonly id: string;

    content: string;

    constructor(props: UserRequestProps) {
        lastId += 1;
        this.id = `${lastId}`;
        this.content = props.content;
    }
}
